export default "__VITE_ASSET__CUBvX1c7__"